import React from "react";

const brands = [
  { img: "/img/brand/brand-09.svg", name: "Chevrolet" },
  { img: "/img/brand/brand-10.svg", name: "Chevrolet" },
  { img: "/img/brand/brand-11.svg", name: "Chevrolet" },
  { img: "/img/brand/brand-12.svg", name: "Chevrolet" },
  { img: "/img/brand/brand-13.svg", name: "Chevrolet" },
  { img: "/img/brand/brand-14.svg", name: "Chevrolet" },
];

const BrandSection = () => {
  return (
    <section className="brand-section">
      <div className="container">

        <div className="section-heading heading-four" data-aos="fade-down">
          <h2 className="text-white">Rent by Brands</h2>
          <p>Here's a list of some of the most popular cars globally</p>
        </div>

        {/* Brand Slider */}
        <div className="brands-slider">
          <div className="row justify-content-center">
            {brands.map((brand, index) => (
              <div key={index} className="col-lg-2 col-md-4 col-6">
                <div className="brand-wrap text-center">
                  <img src={brand.img} alt={brand.name} />
                  <p>{brand.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Background Image */}
        <div className="brand-img text-center">
          <img
            src="/img/bg/brand.png"
            alt="brand background"
            className="img-fluid"
          />
        </div>

      </div>
    </section>
  );
};

export default BrandSection;